import PropTypes from 'prop-types';

export const LoginDefaultProps = {
  errors: [],
};

export const LoginPropTypes = {
  errors: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    ),
  ]),
  onSubmit: PropTypes.func.isRequired,
};
